import React from 'react'
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export class CommonProtectedRoute {

    static common = [

        {
            key: 'modifica-profilo',
            path: `${APP_PREFIX_PATH}/modifica-profilo`,
            component: React.lazy(() => import('views/app-common-views/profilo')),
        },


        {
            key: 'not-found',
            path: `${APP_PREFIX_PATH}/not-found`,
            component: React.lazy(() => import('views/app-common-views/page-not-found')),
        },
    ];

    static getNavTree() {
        return this.common;
    }

}

export default CommonProtectedRoute;
